import React, { useState, useEffect, useRef } from "react";
import CountryDropdown from "../CommonComponent/CountryDropdown";
import ReCAPTCHA from "react-google-recaptcha";
import "./DeleteUserStyle.css";
import {
  Heading,
  Label,
  Input,
  Hint,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  AccentBar,
  Alert,
  Select as NormalSelect,
  SelectOption,
  Checkbox,
} from "@americanexpress/dls-react";
import { withTranslation } from "react-i18next";
import Header from "../Header/Header";
import AuthorizedSignatoryForm from "./AuthorizedSignatoryForm";
import CompanyInfoSection from "./CompanyInfoSection";
import axios from "axios";
import TickIcon from "../../assets/thankyou.svg";
import { Link } from "react-router-dom";
import ErrorIcon from "../../assets/erroricon.svg";
import i18next from "i18next";
import Timer from "../Timer/Timer";
import {
  APPLICATION_JSON,
  COUNTRY_CODE_PREFIX,
  DELETE_USER_ERROR,
  SWEDEN_NORWAY,
  COUNTRY_NAME,
  REGEX,
} from "../Common/constants";
import { v4 } from "uuid";
import TermsAndConditionsWrapper from "../TermsAndConditions/TermsAndConditionsWrapper";
import { shouldUseControlAccountLabel } from "../../util/markets/controlAccountMarkets";

const DeleteUser = (props) => {
  const [userData, setUserData] = useState({
    trid: "",
    users: [
      {
        userId: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        emailId: "",
        deleteAllAccess: false,
        country: "",
        corporateId: "",
        reasonForDelete: "",
        authorizedSignatories: [
          {
            name: "",
            emailId: "",
            phoneNumber: "",
            position: "",
          },
        ],
      },
    ],
  });
  const [signatoryCount, setSignatoryCount] = useState(1);
  const [approversList, setApproversList] = useState([1]);
  const [countryMarketKey, setCountryMarketKey] = useState("");
  const signatoryRefs = useRef([]);
  const [i] = useState(0);
  const [base64, setBase64] = useState("");
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [checked, setChecked] = useState(false);
  const [userFirstNameInvalid, setUserFirstNameInvalid] = useState(false);
  const [userFirstNameEmpty, setUserFirstNameEmpty] = useState(false);
  const [userLastNameInvalid, setUserLastNameInvalid] = useState(false);
  const [userLastNameEmpty, setUserLastNameEmpty] = useState(false);
  const [userEmailEmpty, setUserEmailEmpty] = useState(false);
  const [userEmailInvalid, setUserEmailInvalid] = useState(false);
  const [userPhoneEmpty, setUserPhoneEmpty] = useState(false);
  const [userPhoneInvalid, setUserPhoneInvalid] = useState(false);
  const [display, setDisplay] = useState(false);
  const [signatoryFullNames, setSignatoryFullNames] = useState([
    { fName: "", lName: "" },
  ]);

  const [corporateIDForJapan, setCorporateIDForJapan] = useState(false);
  const [corporateIDForControlAccount, setCorporateIDForControlAccount] =
    useState(false);
  const [corporateIDForOthers, setCorporateIDForOthers] = useState(false);
  const [token, setToken] = useState("");
  const [finalSubmit, setFinalSubmit] = useState(false);
  const googleCaptcha = useRef(null);

  const isOtherCountriesSelected = ![
    props.t("access.JAPAN"),
    props.t("access.UNITEDKINGDOM"),
    props.t("access.SWEDEN"),
    props.t("access.NORWAY"),
    props.t("access.INTERNATIONALEUROCARD"),
  ].includes(userData.users[i].country);

  const countryName = userData.users[i].country;
  let selectedCountry = "";

  if (countryName) {
    selectedCountry = isOtherCountriesSelected
      ? COUNTRY_NAME.OTHERCOUNTRIES
      : countryName;
  }

  useEffect(() => {
    if (finalSubmit) {
      axios({
        method: "get",
        url: "/verifyCaptcha",
        data: {
          token: token,
        },
      })
        .then((res) => {
          toggleConfirm();
        })
        .catch((res) => {
          alert(res.data.error);
        })
        .finally(() => {
          googleCaptcha.current.reset();
          setToken("");
        });
    }
  }, [finalSubmit]);

  /** This one is for validating the User's First name  */
  const validateUserFirstName = () => {
    if (userData.users[i].firstName === "") {
      setUserFirstNameEmpty(true);
    } else {
      setUserFirstNameEmpty(false);
    }
    if (!userData.users[i].firstName.match(/^[a-zA-Z -]*$/)) {
      setUserFirstNameInvalid(true);
    } else {
      setUserFirstNameInvalid(false);
    }
  };

  /** This one is for validating the User's Last name  */
  const validateUserLastName = () => {
    if (userData.users[i].lastName === "") {
      setUserLastNameEmpty(true);
    } else {
      setUserLastNameEmpty(false);
    }
    if (!userData.users[i].lastName.match(/^[a-zA-Z -]*$/)) {
      setUserLastNameInvalid(true);
    } else {
      setUserLastNameInvalid(false);
    }
  };

  /** This one is for validating the User's Email  */
  const validateUserEmail = () => {
    if (userData.users[i].emailId === "") {
      setUserEmailEmpty(true);
    } else {
      setUserEmailEmpty(false);
    }
    if (
      userData.users[i].emailId !== "" &&
      !userData.users[i].emailId.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/,
        // /^[a-zA-Z0-9.]+[-._a-z]*@[a-zA-Z0-9-_]+\.[a-zA-Z.-_]+$/
      )
    ) {
      setUserEmailInvalid(true);
    } else {
      setUserEmailInvalid(false);
    }
  };

  /** This one is for validating the User's Phone number  */
  const validateUserPhone = () => {
    if (userData.users[i].phoneNumber === "") {
      setUserPhoneEmpty(true);
    } else {
      setUserPhoneEmpty(false);
    }
    if (!userData.users[i].phoneNumber.match(/^[0-9+-]*$/)) {
      setUserPhoneInvalid(true);
    } else {
      setUserPhoneInvalid(false);
    }
  };

  /** This function will be called on the change/selection of Form field */
  const updateSavObj = (key, value) => {
    userData.users[i][key] = value;
    setUserData(() => ({
      ...userData,
    }));
  };

  /** For getting Author's full name */
  const getfullNameFor = (index) => {
    const f = signatoryFullNames[index] || { fName: "", lName: "" };
    return `${f.fName || ""} ${f.lName || ""}`.trim();
  };

  /** This function will be called on Authors's first name and last name change and will take
   * those two values and set into the fullName key
   */
  const nameObjFor = (index, key, value) => {
    setSignatoryFullNames((prev) => {
      const next = [...prev];
      next[index] = {
        ...(next[index] || { fName: "", lName: "" }),
        [key]: value,
      };

      setUserData((udPrev) => {
        const udNext = JSON.parse(JSON.stringify(udPrev));
        udNext.users[i].authorizedSignatories =
          udNext.users[i].authorizedSignatories || [];
        if (!udNext.users[i].authorizedSignatories[index]) {
          udNext.users[i].authorizedSignatories[index] = {
            name: "",
            emailId: "",
            phoneNumber: "",
            position: "",
          };
        }
        const f = next[index];
        udNext.users[i].authorizedSignatories[index].name =
          `${f.fName || ""} ${f.lName || ""}`.trim();
        return udNext;
      });

      return next;
    });
  };

  /** This function will be called on onchange event for getting Author's details */
  const authSaveObjFor = (index, key, value) => {
    setUserData((prev) => {
      const next = JSON.parse(JSON.stringify(prev));
      next.users[i].authorizedSignatories =
        next.users[i].authorizedSignatories || [];
      if (!next.users[i].authorizedSignatories[index]) {
        next.users[i].authorizedSignatories[index] = {
          name: "",
          emailId: "",
          phoneNumber: "",
          position: "",
        };
      }
      next.users[i].authorizedSignatories[index][key] = value;
      next.users[i].authorizedSignatories[index].name = getfullNameFor(index);
      return next;
    });
  };

  useEffect(() => {
    setSignatoryFullNames((prev) => {
      const next = [...prev];
      while (next.length < signatoryCount) next.push({ fName: "", lName: "" });
      if (next.length > signatoryCount) next.length = signatoryCount;
      return next;
    });

    if (!signatoryRefs.current) signatoryRefs.current = [];
    for (let index = 0; index < signatoryCount; index++) {
      if (!signatoryRefs.current[index])
        signatoryRefs.current[index] = React.createRef();
    }
    if (signatoryRefs.current.length > signatoryCount) {
      signatoryRefs.current.length = signatoryCount;
    }

    setUserData((prev) => {
      const next = JSON.parse(JSON.stringify(prev));
      next.users[i].authorizedSignatories =
        next.users[i].authorizedSignatories || [];
      while (next.users[i].authorizedSignatories.length < signatoryCount) {
        next.users[i].authorizedSignatories.push({
          name: "",
          emailId: "",
          phoneNumber: "",
          position: "",
        });
      }
      if (next.users[i].authorizedSignatories.length > signatoryCount) {
        next.users[i].authorizedSignatories.length = signatoryCount;
      }

      for (
        let index = 0;
        index < next.users[i].authorizedSignatories.length;
        index++
      ) {
        const f = signatoryFullNames[index] || { fName: "", lName: "" };
        next.users[i].authorizedSignatories[index].name =
          `${f.fName || ""} ${f.lName || ""}`.trim();
      }

      return next;
    });
  }, [signatoryCount]);

  /** This function will set the value on checking of T&C checkbox  */
  const getchecked = (value) => {
    if (value === "yes") {
      setChecked(true);
    }
  };

  /** This function will be called on click of Submit button */
  const onSubmit = () => {
    setSubmit(true);
    checkEmpty();
  };

  /** This function will be used for calling the Delete User API */
  const handleSubmit = async (dataobj) => {
    let finalobj = JSON.parse(JSON.stringify(dataobj));
    finalobj.language = i18next.language === "jap" ? "ja" : "en";

    await axios({
      method: "post",
      url: "/deleteuser",
      headers: {
        "Content-Type": APPLICATION_JSON,
        "one-data-correlation-id": v4(),
      },
      data: finalobj,
    })
      .then((res) => {
        if (
          Object.keys(res.data).length > 0 &&
          res.data.transactionId !== undefined
        ) {
          setSuccess(true);
          setBase64(res.data.documentContent);
          setUserData(() => ({
            ...userData,
            trid: res.data.transactionId,
          }));
        } else {
          setFail(true);
        }
      })
      .catch((err) => {
        console.log(DELETE_USER_ERROR, err);
      });
  };

  /** This function will checks the required fields length */
  const checkEmpty = () => {
    let obj = { ...userData.users[i] };
    const authArray = userData.users[i].authorizedSignatories || [];
    const nameArray = signatoryFullNames || [];

    if (obj.firstName !== "" && obj.firstName.match(/^[a-zA-Z -]*$/) === null) {
      return false;
    }
    if (obj.lastName !== "" && obj.lastName.match(/^[a-zA-Z -]*$/) === null) {
      return false;
    }
    if (obj.emailId !== "" && obj.emailId.match(REGEX.EMAIL) === null) {
      return false;
    }
    if (
      obj.phoneNumber !== "" &&
      obj.phoneNumber.match(/^[0-9+-]*$/) === null
    ) {
      return false;
    }

    for (let index = 0; index < signatoryCount; index++) {
      const auth = authArray[index] || {
        name: "",
        emailId: "",
        phoneNumber: "",
        position: "",
      };
      const nameEntry = nameArray[index] || { fName: "", lName: "" };

      if (auth.emailId !== "" && auth.emailId.match(REGEX.EMAIL) === null) {
        return false;
      }
      if (
        auth.phoneNumber !== "" &&
        auth.phoneNumber.match(REGEX.PHONE) === null
      ) {
        return false;
      }
      if (
        auth.position !== "" &&
        auth.position.match(REGEX.POSITION_ALPHA) === null
      ) {
        return false;
      }
      if (
        (nameEntry.fName !== "" &&
          nameEntry.fName.match(REGEX.NAME_ALPHA) === null) ||
        (nameEntry.lName !== "" &&
          nameEntry.lName.match(/^[a-zA-Z]*$/) === null)
      ) {
        return false;
      }
    }

    for (var key in obj) {
      if (
        obj[key] === "" &&
        key !== "userId" &&
        !obj.deleteAllAccess &&
        props.i18n.language === "en"
      ) {
        return false;
      }
    }
    for (var key in obj) {
      if (
        obj[key] === "" &&
        key === "userId" &&
        props.i18n.language === "jap"
      ) {
        return false;
      }
    }

    for (let index = 0; index < signatoryCount; index++) {
      const auth = authArray[index] || {};
      const keys = ["name", "emailId", "phoneNumber", "position"];
      for (const k of keys) {
        if (!auth[k] || auth[k] === "") return false;
      }
    }
    if (!obj.deleteAllAccess && props.i18n.language === "en") {
      if (obj.corporateId.length < 15 && obj.country === t("access.JAPAN")) {
        return false;
      }
      if (
        obj.corporateId.length !== 9 &&
        obj.corporateId.length !== 15 &&
        obj.country === t("access.UNITEDKINGDOM")
      ) {
        return false;
      }
      if (
        obj.country === t("access.UNITEDKINGDOM") &&
        !obj.corporateId.includes("036")
      ) {
        return false;
      }
      if (shouldAcceptControlAccount) {
        const marketCode = COUNTRY_CODE_PREFIX[countryMarketKey];
        if (
          !REGEX.NUMBER.test(obj.corporateId) ||
          (obj.corporateId.length !== 9 && obj.corporateId.length !== 15) ||
          !obj.corporateId.includes(marketCode)
        ) {
          return false;
        }
      }
      if (
        obj.corporateId.length < 15 &&
        obj.country !== t("access.JAPAN") &&
        !shouldAcceptControlAccount
      ) {
        return false;
      }
    }

    if (checked) {
      let allValid = true;
      for (let index = 0; index < signatoryCount; index++) {
        const ref = signatoryRefs.current[index];
        if (ref && ref.current && typeof ref.current.validate === "function") {
          const valid = ref.current.validate();
          if (!valid) {
            allValid = false;
          }
        }
      }
      if (allValid) {
        setFinalSubmit(true);
        return true;
      }
    }
  };

  /** This one will display the Modal on Success state */
  const toggleConfirm = () => {
    setDisplay(!display);
    handleSubmit(userData);
  };

  /** This function will take to Home page on clikc of button */
  const redirectToHome = () => {
    setSuccess(false);
    props.history.push("/");
  };

  /** This function will be called on Country change */
  const handleCountrySelect = (key, value, marketKey) => {
    userData.users[i][key] = value;
    userData.users[i].corporateId = "";
    setCountryMarketKey(marketKey);
    setUserData(() => ({
      ...userData,
    }));
    setSignatoryCount(1);

    switch (value) {
      case COUNTRY_NAME.NORWAY:
        setApproversList([1, 2, 3]);
        break;
      case COUNTRY_NAME.SWEDEN:
        setApproversList([1, 2]);
        break;
      default:
        setApproversList([1]);
    }
  };

  /** This function will be called on change of Corporate ID */
  const updateCorporateId = (key, value) => {
    const { t } = props;
    userData.users[i][key] = value;
    if (
      userData.users[i].corporateId.length < 2 &&
      userData.users[i].country === t("access.JAPAN")
    ) {
      userData.users[i].corporateId = "010" + value;
    } else {
      userData.users[i].corporateId = value;
    }
    setUserData(() => ({
      ...userData,
    }));
  };

  /** This function will remove the Corporate ID field
   * on the selection of Remove Access Checkbox
   */
  const handleDeleteAllAccess = () => {
    userData.users[i].deleteAllAccess = !userData.users[i].deleteAllAccess;
    userData.users[i].corporateId = "";
    setUserData(() => ({
      ...userData,
    }));
  };

  /** This function will set the prefix for the Corporate ID based on country selection */
  const prefixCorporateId = () => {
    let prefix = "";
    const { t } = props;

    switch (userData.users[i].country) {
      case t("access.AUSTRALIA"):
        prefix = COUNTRY_CODE_PREFIX.AUSTRALIA;
        break;
      case t("access.NEWZEALAND"):
        prefix = COUNTRY_CODE_PREFIX.NEWZEALAND;
        break;
      case t("access.INDIA"):
        prefix = COUNTRY_CODE_PREFIX.INDIA;
        break;
      case t("access.SINGAPORE"):
        prefix = COUNTRY_CODE_PREFIX.SINGAPORE;
        break;
      case t("access.HONGKONG"):
        prefix = COUNTRY_CODE_PREFIX.HONGKONG;
        break;
      case t("access.THAILAND"):
        prefix = COUNTRY_CODE_PREFIX.THAILAND;
        break;
      case t("access.TAIWAN"):
        prefix = COUNTRY_CODE_PREFIX.TAIWAN;
        break;
      case t("access.NORWAY"):
        prefix = COUNTRY_CODE_PREFIX.NORWAY;
        break;
      case t("access.SWEDEN"):
        prefix = COUNTRY_CODE_PREFIX.SWEDEN;
        break;
      case t("access.INTERNATIONALEUROCARD"):
        prefix = COUNTRY_CODE_PREFIX.INTERNATIONALEUROCARD;
        break;
      case t("access.UNITEDKINGDOM"):
        prefix = COUNTRY_CODE_PREFIX.UNITEDKINGDOM;
        break;
      default:
        prefix = "";
    }

    if (userData.users[i].corporateId.match(/^[0-9]*$/)) {
      if (
        userData.users[i].country === t("access.JAPAN") &&
        userData.users[i].corporateId.length !== 15
      ) {
        setCorporateIDForJapan(true);
        setCorporateIDForOthers(false);
        setCorporateIDForControlAccount(false);
      }
      if (
        shouldAcceptControlAccount &&
        (userData.users[i].corporateId.length !== 15 ||
          userData.users[i].corporateId.length !== 9)
      ) {
        setCorporateIDForJapan(false);
        setCorporateIDForOthers(false);
        setCorporateIDForControlAccount(true);
      }

      if (
        userData.users[i].country === t("access.JAPAN") &&
        userData.users[i].corporateId.length === 15
      ) {
        setCorporateIDForJapan(false);
        setCorporateIDForOthers(false);
        setCorporateIDForControlAccount(false);
      }
      if (
        shouldAcceptControlAccount &&
        (userData.users[i].corporateId.length === 15 ||
          userData.users[i].corporateId.length === 9)
      ) {
        if (!userData.users[i].corporateId.includes(prefix)) {
          setCorporateIDForControlAccount(true);
        }
        if (userData.users[i].corporateId.includes(prefix)) {
          setCorporateIDForControlAccount(false);
        }
      }

      if (
        userData.users[i].country !== t("access.JAPAN") &&
        !shouldAcceptControlAccount &&
        userData.users[i].corporateId.length !== 6
      ) {
        setCorporateIDForJapan(false);
        setCorporateIDForOthers(true);
        setCorporateIDForControlAccount(false);
      }

      if (
        userData.users[i].country !== t("access.JAPAN") &&
        !shouldAcceptControlAccount &&
        userData.users[i].corporateId.length === 6
      ) {
        userData.users[i].corporateId = prefix + userData.users[i].corporateId;
        setUserData(() => ({
          ...userData,
        }));
        setCorporateIDForJapan(false);
        setCorporateIDForOthers(false);
        setCorporateIDForControlAccount(false);
      }
      if (
          shouldAcceptControlAccount &&
        (userData.users[i].corporateId.length === 6 ||
          userData.users[i].corporateId.length === 12)
      ) {
        userData.users[i].corporateId = prefix + userData.users[i].corporateId;
        setUserData(() => ({
          ...userData,
        }));
        setCorporateIDForJapan(false);
        setCorporateIDForOthers(false);
        setCorporateIDForControlAccount(false);
      }

      if (
        userData.users[i].corporateId.length === 15 &&
        userData.users[i].country !== t("access.JAPAN") &&
        !shouldAcceptControlAccount
      ) {
        setCorporateIDForOthers(false);
      }
    }

    if (!userData.users[i].corporateId.match(/^[0-9]*$/)) {
      if (
        userData.users[i].country !== t("access.JAPAN") &&
        !shouldAcceptControlAccount
      ) {
        setCorporateIDForJapan(false);
        setCorporateIDForOthers(true);
        setCorporateIDForControlAccount(false);
      }
      if (
        shouldAcceptControlAccount
      ) {
        setCorporateIDForJapan(false);
        setCorporateIDForOthers(false);
        setCorporateIDForControlAccount(true);
      }
      if (userData.users[i].country === t("access.JAPAN")) {
        setCorporateIDForJapan(true);
        setCorporateIDForOthers(false);
        setCorporateIDForControlAccount(false);
      }
    }
  };

  const { t } = props;
  const shouldAcceptControlAccount =
    shouldUseControlAccountLabel(countryMarketKey);

  return (
    <>
      <Header />
      <section id="delete-user-page" className="deletePage mainBody">
        <div className="container">
          <div className="row">
            <section id="user-details" className="col-md-6 col-xs-12">
              <Heading
                level={1}
                headingStyle={"heading5"}
                className="margin-1-b"
              >
                {t("deleteuser.heading")}
              </Heading>

              <hr className="hrLine" />

              <Heading level={4} className={"heading-4 dls-deep-blue pad-1-b"}>
                {t("deleteuser.title")}
              </Heading>
              <Hint className="pad-1-b">{t("deleteuser.userText")}</Hint>

              <div className="row">
                <div className="col-md-6 col-xs-12 pad-2-b">
                  <Label htmlFor="userId">{t("deleteuser.userid")}</Label>
                  <Input
                    id="userId"
                    value={userData.users[i].userId}
                    onChange={(event) => {
                      updateSavObj("userId", event.target.value);
                    }}
                  />

                  {props.i18n.language === "jap" &&
                    submit &&
                    userData.users[i].userId === "" && (
                      <Alert status="error">
                        {t("deleteuser.useridrequired")}
                      </Alert>
                    )}
                  {props.i18n.language === "en" &&
                    !userData.users[i].userId.match(REGEX.USER_ID) && (
                      <Alert status="error">
                        {t("deleteuser.useriderror")}
                      </Alert>
                    )}
                </div>

                {props.i18n.language === "en" && (
                  <div className="col-md-6 col-xs-12 pad-2-b">
                    <Label htmlFor="deleteCountry">
                      {t("confirm.country")}
                    </Label>

                    <CountryDropdown
                      country={userData.users[i].country}
                      handleCountrySelectChange={handleCountrySelect}
                      languageSelected={props.i18n.language}
                    />

                    {submit && userData.users[i].country === "" && (
                      <Alert status="error">{t("access.countryValid")}</Alert>
                    )}
                  </div>
                )}
              </div>
              <div className="row ">
                <div className="col-md-12 col-xs-12 pad-2-b">
                  {userData.users[i].country === t("access.INDIA") && (
                    <Hint className="pad-2-b">
                      {t("deleteuser.approverTextIndia")}
                    </Hint>
                  )}
                </div>
              </div>
              {props.i18n.language === "en" && (
                <div className="row">
                  <div className="col-md-6 col-xs-12 pad-2-b pad-2-t">
                    <Checkbox
                      label="Click here to remove all access for this PA"
                      id={Math.random()}
                      value={userData.users[i].deleteAllAccess}
                      checked={userData.users[i].deleteAllAccess}
                      onChange={handleDeleteAllAccess}
                      defaultChecked={false}
                    />
                  </div>
                  {!userData.users[i].deleteAllAccess && (
                    <div className="col-md-6 col-xs-12 pad-2-b">
                      <Label htmlFor="corporateId">
                        {shouldAcceptControlAccount
                          ? t("access.controlAccountNumberCid")
                          : t("access.corporateId")}
                      </Label>
                      <Input
                        placeholder={
                          countryMarketKey === "INTERNATIONALEUROCARD"
                            ? t("access.controlAccountNumberCid")
                            : undefined
                        }
                        value={userData.users[i].corporateId}
                        onChange={(event) => {
                          updateCorporateId("corporateId", event.target.value);
                        }}
                        onBlur={prefixCorporateId}
                        maxLength={
                          userData.users[i].country === t("access.JAPAN")
                            ? "15"
                              : shouldAcceptControlAccount
                              ? "15"
                              : "6"
                        }
                      />

                      {userData.users[i].country === t("access.JAPAN") ? (
                        <Hint>{t("access.controlvalidjapa")}</Hint>
                      ) : shouldAcceptControlAccount ? (
                        <Hint>{t("access.controlAccountNumberCidHint")}</Hint>
                      ) : userData.users[i].country === "" ? null : (
                        <Hint>{t("access.controlacnum")}</Hint>
                      )}

                      {corporateIDForOthers &&
                        !userData.users[i].deleteAllAccess && (
                          <Alert status="error">
                            {t("access.controlvalid")}
                          </Alert>
                        )}

                      {corporateIDForJapan &&
                        !userData.users[i].deleteAllAccess && (
                          <Alert status="error">
                            {t("access.controlvalidjapa")}
                          </Alert>
                        )}

                      {corporateIDForControlAccount &&
                        !userData.users[i].deleteAllAccess && (
                          <Alert status="error">
                            {t("access.controlAccountNumberCidHint")}
                          </Alert>
                        )}

                      {submit &&
                        !userData.users[i].deleteAllAccess &&
                        userData.users[i].corporateId === "" && (
                          <Alert status="error">Corporate Id Required</Alert>
                        )}
                    </div>
                  )}
                </div>
              )}

              <div className="row">
                {props.i18n.language === "en" ? (
                  <>
                    <div className="col-md-6 col-xs-12 pad-2-b">
                      <Label htmlFor="firstName">{t("newuser.fn")}</Label>
                      <Input
                        id="firstName"
                        value={userData.users[i].firstName}
                        onChange={(event) => {
                          updateSavObj("firstName", event.target.value);
                        }}
                        onBlur={validateUserFirstName}
                      />
                      {(userFirstNameEmpty ||
                        (submit && userData.users[i].firstName === "")) && (
                        <Alert status="error">{t("newuser.fnrequired")}</Alert>
                      )}
                      {(userFirstNameInvalid ||
                        (submit &&
                          !userData.users[i].firstName.match(
                            /^[a-zA-Z -]*$/,
                          ))) && (
                        <Alert status="error">{t("newuser.fnerror")}</Alert>
                      )}
                    </div>
                    <div className="col-md-6 col-xs-12 pad-2-b">
                      <Label htmlFor="lastName">{t("newuser.ln")}</Label>
                      <Input
                        id="lastName"
                        value={userData.users[i].lastName}
                        onChange={(event) => {
                          updateSavObj("lastName", event.target.value);
                        }}
                        onBlur={validateUserLastName}
                      />

                      {(userLastNameEmpty ||
                        (submit && userData.users[i].lastName === "")) && (
                        <Alert status="error">{t("newuser.lnrequired")}</Alert>
                      )}
                      {(userLastNameInvalid ||
                        (submit &&
                          !userData.users[i].lastName.match(
                            /^[a-zA-Z -]*$/,
                          ))) && (
                        <Alert status="error">{t("newuser.lnerror")}</Alert>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-md-6 col-xs-12 pad-2-b">
                      <Label htmlFor="lastName">{t("newuser.ln")}</Label>
                      <Input
                        id="lastName"
                        value={userData.users[i].lastName}
                        onChange={(event) => {
                          updateSavObj("lastName", event.target.value);
                        }}
                        onBlur={validateUserLastName}
                      />

                      {(userLastNameEmpty ||
                        (submit && userData.users[i].lastName === "")) && (
                        <Alert status="error">{t("newuser.lnrequired")}</Alert>
                      )}
                    </div>
                    <div className="col-md-6 col-xs-12 pad-2-b">
                      <Label htmlFor="firstName">{t("newuser.fn")}</Label>
                      <Input
                        id="firstName"
                        value={userData.users[i].firstName}
                        onChange={(event) => {
                          updateSavObj("firstName", event.target.value);
                        }}
                        onBlur={validateUserFirstName}
                      />
                      {(userFirstNameEmpty ||
                        (submit && userData.users[i].firstName === "")) && (
                        <Alert status="error">{t("newuser.fnrequired")}</Alert>
                      )}
                    </div>
                  </>
                )}
              </div>

              <div className="row">
                <div className="col-md-12 col-xs-12 pad-2-b">
                  <Label htmlFor="userEmail">{t("common.EmailAddress")}</Label>
                  <Input
                    id="userEmail"
                    value={userData.users[i].emailId}
                    onChange={(event) => {
                      updateSavObj("emailId", event.target.value);
                    }}
                    onBlur={validateUserEmail}
                  />
                  {(userEmailEmpty ||
                    (submit && userData.users[i].emailId === "")) && (
                    <Alert status="error">{t("newuser.emailrequired")}</Alert>
                  )}
                  {(userEmailInvalid ||
                    (submit &&
                      userData.users[i].emailId !== "" &&
                      !userData.users[i].emailId.match(REGEX.EMAIL))) && (
                    <Alert status="error">{t("newuser.emailerror")}</Alert>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-xs-12 pad-2-b">
                  <Label htmlFor="userPhone">
                    {t("common.TelephoneNumber")}
                  </Label>
                  <Input
                    id="userPhone"
                    value={userData.users[i].phoneNumber}
                    onChange={(event) => {
                      updateSavObj("phoneNumber", event.target.value);
                    }}
                    onBlur={validateUserPhone}
                  />
                  {props.i18n.language === "en" && (
                    <Hint>{t("common.TelephoneInfoMessage")}</Hint>
                  )}
                  {(userPhoneEmpty ||
                    (submit && userData.users[i].phoneNumber === "")) && (
                    <Alert status="error">{t("newuser.phnrequired")}</Alert>
                  )}
                  {(userPhoneInvalid ||
                    (submit &&
                      !userData.users[i].phoneNumber.match(/^[0-9+-]*$/))) && (
                    <Alert status="error">{t("newuser.phnerror")}</Alert>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-xs-12 reasonSelect">
                  <Label htmlFor="deleteReason">{t("deleteuser.reason")}</Label>
                  <NormalSelect
                    id="deleteReason"
                    value={userData.users[i].reasonForDelete}
                    onChange={(event) => {
                      updateSavObj("reasonForDelete", event.target.value);
                    }}
                  >
                    <SelectOption value="" />
                    <SelectOption
                      value="Has left the Company"
                      data-label="Has left the Company"
                    >
                      {t("deleteuser.option1")}
                    </SelectOption>

                    <SelectOption
                      value="Has changed roles"
                      data-label="Has changed roles"
                    >
                      {t("deleteuser.option2")}
                    </SelectOption>

                    <SelectOption
                      value="Prefers to use email or call"
                      data-label="Prefers to use email or call"
                    >
                      {t("deleteuser.option3")}
                    </SelectOption>

                    <SelectOption
                      value="Dissatisfied with @ Work"
                      data-label="Dissatisfied with @ Work"
                    >
                      {t("deleteuser.option4")}
                    </SelectOption>
                  </NormalSelect>

                  {submit && userData.users[i].reasonForDelete === "" && (
                    <Alert status="error">
                      {t("deleteuser.reasonrequired")}
                    </Alert>
                  )}
                </div>
              </div>
            </section>

            <section id="access-approval" className="col-md-6 col-xs-12">
              <div className="authorizedBox">
                <div className="timer">
                  <Timer time={"1"} hist={props.history} />
                </div>

                <AccentBar />

                <div id="auth-form" className="pad-1-t pad-2-l pad-2-r pad-2-b">
                  <Hint className="authHint">
                    {t("deleteuser.approverText")}
                  </Hint>
                  {userData.users[i].country === t("access.INDIA") && (
                    <Hint className="pad-2-b">
                      {t("deleteuser.approverTextIndia")}
                    </Hint>
                  )}

                  {SWEDEN_NORWAY.includes(userData.users[i].country) && (
                    <div className="row pad-1-b">
                      <Label
                        className="col-md-6 col-xs-12"
                        htmlFor="signatoryCount"
                      >
                        {t("access.choose")}
                      </Label>
                      <NormalSelect
                        className="col-md-6 col-xs-12"
                        id="signatoryCount"
                        value={String(signatoryCount)}
                        onChange={(e) =>
                          setSignatoryCount(Number(e.target.value))
                        }
                      >
                        {approversList.map((acc) => (
                          <SelectOption
                            key={`${acc?.country}-${acc}`}
                            value={acc}
                          >
                            {acc}
                          </SelectOption>
                        ))}
                      </NormalSelect>
                    </div>
                  )}

                  {[...Array(signatoryCount)].map((_, index) => {
                    if (!signatoryRefs.current[index])
                      signatoryRefs.current[index] = React.createRef();
                    const nameObjBound = (key, value) =>
                      nameObjFor(index, key, value);
                    const authSaveObjBound = (key, value) =>
                      authSaveObjFor(index, key, value);
                    return (
                      <AuthorizedSignatoryForm
                        key={index}
                        ref={signatoryRefs.current[index]}
                        t={t}
                        language={props.i18n.language}
                        userDataUser={userData.users[i]}
                        index={index}
                        fullName={
                          signatoryFullNames[index] || { fName: "", lName: "" }
                        }
                        nameObj={nameObjBound}
                        authSaveObj={authSaveObjBound}
                        submit={submit}
                      />
                    );
                  })}

                  <div className="row">
                    <div className="col-md-12 col-xs-12">
                      {selectedCountry && (
                        <TermsAndConditionsWrapper
                          selectedCountries={[selectedCountry]}
                          getChecked={getchecked}
                          lang={props.i18n.language}
                        />
                      )}

                      {submit && !checked && (
                        <Alert status="error">{t("access.terms-check")}</Alert>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {SWEDEN_NORWAY.includes(userData.users[i].country) && (
              <>
                <hr className="margin-3-t" />
                <CompanyInfoSection
                  submit={submit}
                  updateSavobj={updateSavObj}
                  user={userData.users[i]}
                />
              </>
            )}
          </div>
        </div>

        <hr className="hrSimpleLine" />

        <div id="captchaButton" className="container">
          <div className="row">
            <div className="col-xs-4 col-xs-offset-8">
              <div className="margin-2-b float-right">
                <ReCAPTCHA
                  sitekey="6LeMcCUaAAAAAERRHEXpgOdMbvCy6OhCiN3jRh4Q"
                  ref={googleCaptcha}
                  onChange={(token) => setToken(token)}
                  onExpired={(e) => setToken("")}
                />
              </div>

              <Button
                styleType="primary"
                onClick={onSubmit}
                className="float-right"
              >
                {t("deleteuser.submit")}
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/** Success Modal*/}
      {submit && display && success && (
        <Modal className="deleteThankYouModal">
          <ModalBody>
            <div className="modalBody">
              <div className="successIcon">
                <img src={TickIcon} alt="successIcon" />
              </div>
              <h2 className="thanksTitle">{t("thankYou.title")}</h2>

              <h4>
                {t("deleteuser.request")} <br />
                {t("thankYou.userTransactionId")} {userData.trid}
              </h4>

              {userData.users[i].userId !== "" && (
                <b>
                  {t("newuser.userid")}: {userData.users[i].userId}
                </b>
              )}
            </div>
          </ModalBody>
          <ModalFooter className="modalFooter">
            <a
              href={`data:application/pdf;base64,${base64}`}
              download={`American Express @ Work®.pdf`}
            >
              <Button styleType="primary" className="button">
                {t("newuser.save")}
              </Button>
            </a>
            <Button styleType="primary" onClick={redirectToHome}>
              {t("confirm.goToHome")}
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/**  Error Modal*/}
      {fail && (
        <Modal className="deleteErrorMsgModal">
          <ModalBody className="modalBody">
            <img src={ErrorIcon} alt="errorIcon" />
            <h4>There is some error in the form submission</h4>
            <p className="pad-2-b">Please try again later.</p>
          </ModalBody>
          <ModalFooter className="modalFooter">
            <Link to="/delete-user">
              <Button styleType="primary">Start Again</Button>
            </Link>
            <Link to="/">
              <Button>Go to Home</Button>
            </Link>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};
export default withTranslation("common")(DeleteUser);
